module.exports = {"500110001":"古南街道","500110002":"文龙街道","500110003":"三江街道","500110004":"万盛街道","500110005":"东林街道","500110100":"万东镇","500110101":"南桐镇","500110102":"青年镇","500110103":"关坝镇","500110104":"丛林镇","500110105":"石林镇","500110106":"金桥镇","500110107":"黑山镇","500110108":"石角镇","500110109":"东溪镇","500110110":"赶水镇","500110111":"打通镇","500110112":"石壕镇","500110113":"永新镇","500110114":"三角镇","500110115":"隆盛镇","500110116":"郭扶镇","500110117":"篆塘镇","500110118":"丁山镇","500110119":"安稳镇","500110120":"扶欢镇","500110121":"永城镇","500110122":"新盛镇","500110123":"中峰镇","500110124":"横山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500110.json
// module id = 2044
// module chunks = 0